const style = ({ COLORS }) => ({
  container: ({ size }) => ({
    padding: `${size(3.5)} ${size(4)} 0`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }),
  title: ({ size }) => ({
    color: '#fff',
    margin: `0 0 ${size(3)}`
  }),
  paper: ({ size }) => ({
    position: 'relative',
    padding: `${size(3.5)} ${size(4)} ${size(3.2)}`,
    background: '#fff',
    borderRadius: '10px 10px 0 0',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '0'
  }),
  exercise: ({ size, printMode }) => ({
    color: COLORS.TEXT.DARK_GREY.NORMAL,
    fontSize: printMode ? '14px' : size(2, { scaleFactor: 'lg' }),
    lineHeight: '2',
    overflowY: printMode ? 'hidden' : 'auto',
    marginBottom: size(1)
  }),
  options: {
    flexShrink: '0',
    display: 'flex',
    flexWrap: 'wrap'
  },
  reset: ({ size }) => ({
    position: 'absolute',
    right: size(0.8, { scaleFactor: 'sm' }),
    top: `${size(-2.4, { scaleFactor: 'sm' })}`
  })
})

export default style
